import React from "react";

// Material
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useMediaQuery } from "@material-ui/core";

// Assets
import background from "../../assets/backgrounds/evidence-collection-bg.png";

// Mobile Backgrounds
import incidentMobileBg from "../../assets/backgrounds/incident-mobile-bg.png";
import storingBg1 from "../../assets/backgrounds/storingBg1.svg";
import storingBg2 from "../../assets/backgrounds/storingBg2.svg";

// Components
import Section from "../Section/Section";
import Text, { types } from "../Text/Text";

// Contents
import EvidenceCollectionDesktop from "./EvidenceCollectionDesktop";
import HomeSubsectionResponsive from "../HomeSubsection/HomeSubsectionResponsive";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundImage: `url(${background})`,
    backgroundSize: "cover",
    backgroundPosition: "top center",
    backgroundRepeat: "no-repeat",
    minHeight: 1500,
    paddingBottom: 100,
    position: "relative",
    overflowX: "hidden",
    width: "100vw",
    paddingRight: "2.4vw",
    paddingLeft: "2.4vw",
    [theme.breakpoints.down("md")]: {
      minHeight: 1100,
      paddingBottom: 40
    },
    [theme.breakpoints.down("sm")]: {
      minHeight: 0,
      backgroundImage: "none",
      paddingRight: "0",
      paddingLeft: "0"
    }
  },
  storingBg1: {
    pointerEvents: "none",
    position: "absolute",
    top: -10,
    left: -40
  },
  storingBg2: {
    pointerEvents: "none",
    position: "absolute",
    top: 360,
    right: 0,
    transform: "translateX(70px)"
  },
  mainTitle: {
    maxWidth: 700,
    textAlign: "center",
    zIndex: 99,
    [theme.breakpoints.down("sm")]: {
      maxWidth: "90%"
    }
  }
}));

const subsections = [
  {
    id: "incident",
    heading: "Incident Details",
    description: "What happened?",
    title:
      "What happened, when and where. A reliable chain of evidence starts with the basics.",
    descriptions: [],
    mobileBg: incidentMobileBg
    // background: incidentDetailsBg,
  },
  {
    id: "evidence",
    heading: "Supporting Evidence",
    description: "Upload any and all supporting evidence",
    title:
      "Upload any and all files that help prove what happened - consider uploading photos, videos, CCTV, DashCam, audio recordings, social media, screenshots, messages, emails, documents or any other file.",
    descriptions: []
    // background: supportingBg,
    // mobileBg: supportingMobileBg
  },
  {
    id: "injuries",
    heading: "Physical Damage and Injuries",
    description: "Take forensic photographs",
    title:
      "Use kulpa’s proprietary in-app technology to take scaled forensic images of any physical damage or physical injuries. Forensic evidence is the best evidence.",
    descriptions: []
    // background: injuriesBg,
    // mobileBg: injuriesMobileBg
  },
  {
    id: "records",
    heading: "Medical Records",
    description: "Add relevant medical records",
    title:
      "If you were injured, physically or mentally, upload the relevant medical records or associated evidence.",
    descriptions: []
    // background: recordsBg,
    // mobileBg: recordsMobileBg
  },
  {
    id: "info",
    heading: "Information Requests",
    description:
      "Additional information can be requested from other case contributors",
    title:
      "If someone else has evidence that can support your case, invite them to contribute it directly to your file. You can also communicate with them using the in-app chat.",
    descriptions: []
    // background: infoBg,
    // mobileBg: infoMobileBg
  }
];

const mainTitle = `Build Your Evidence File`;

const EvidenceCollectionSection = () => {
  const classes = useStyles();
  const isMobile = useMediaQuery(useTheme().breakpoints.down("sm"));

  return (
    <Section className={classes.root} id="evidence">
      {isMobile && (
        <>
          <img src={storingBg1} alt="" className={classes.storingBg1} />
          <img src={storingBg2} alt="" className={classes.storingBg2} />
        </>
      )}
      <Text
        type={types.miniSectionTitle}
        className={classes.mainTitle}
        component="h2"
      >
        {mainTitle}
      </Text>
      {isMobile ? (
        <HomeSubsectionResponsive subsections={subsections} />
      ) : (
        <EvidenceCollectionDesktop subsections={subsections} />
      )}
    </Section>
  );
};

export default EvidenceCollectionSection;
